import type { TeamLogoVariant } from '@lottocom/frontend-lotteries'

export const useXsAndOsLogoVariant = (): TeamLogoVariant =>
  useIsFeatureFlagEnabled('xsAndOsTeamLogos') ? 'team' : 'helmet'
